import { render, staticRenderFns } from "./WsAccredidation.vue?vue&type=template&id=0dfa8e88"
import script from "./WsAccredidation.vue?vue&type=script&lang=js"
export * from "./WsAccredidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports